import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './PublicFooter.css';

const PublicFooter = () => {
  return (
    <footer className="py-5" style={{ backgroundColor: 'white', borderTop: '3px solid #55c900' }}>
      <Container>
        <Row className="gy-4">
          <Col lg={5} md={12}>
            <div className="mb-3">
              <img 
                width={100} 
                src="/assets/images/bhit-logo.png" 
                alt="BHIT Infotech"
              />
            </div>
            <p style={{ color: '#666' }}>
              BHIT Infotech is committed to delivering cutting-edge digital solutions that empower businesses to thrive
              in a technology-driven world. With a focus on innovation, quality, and customer success, we help transform ideas into reality through reliable IT services.
            </p>
            <div className="d-flex gap-3 mt-3">
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-icon">
                <i className="bi bi-twitter-x" style={{ fontSize: '1.5rem' }}></i>
              </a>
              <a href="https://www.facebook.com/profile.php?id=61577832045810" target="_blank" rel="noopener noreferrer" className="social-icon">
                <i className="bi bi-facebook" style={{ fontSize: '1.5rem' }}></i>
              </a>
              <a href="https://www.instagram.com/bhit_infotech/" target="_blank" rel="noopener noreferrer" className="social-icon">
                <i className="bi bi-instagram" style={{ fontSize: '1.5rem' }}></i>
              </a>
              <a href="https://www.linkedin.com/company/110883158/" target="_blank" rel="noopener noreferrer" className="social-icon">
                <i className="bi bi-linkedin" style={{ fontSize: '1.5rem' }}></i>
              </a>
            </div>
          </Col>

          <Col lg={2} sm={6}>
            <h5 className="fw-bold mb-3" style={{ color: '#00428a' }}>Useful Links</h5>
            <ul className="list-unstyled">
              <li className="mb-2"><a href="#" className="footer-link">Home</a></li>
              <li className="mb-2"><a href="#about" className="footer-link">About us</a></li>
              <li className="mb-2"><a href="#services" className="footer-link">Services</a></li>
              <li className="mb-2"><a href="#contact" className="footer-link">Contact Us</a></li>
            </ul>
          </Col>

          <Col lg={2} sm={6}>
            <h5 className="fw-bold mb-3" style={{ color: '#00428a' }}>Our Services</h5>
            <ul className="list-unstyled">
              <li className="mb-2"><a href="#services" className="footer-link">IT Training</a></li>
              <li className="mb-2"><a href="#services" className="footer-link">Web Development</a></li>
              <li className="mb-2"><a href="#services" className="footer-link">Product Management</a></li>
              <li className="mb-2"><a href="#services" className="footer-link">Digital Marketing</a></li>
              <li className="mb-2"><a href="#services" className="footer-link">Graphic Design</a></li>
            </ul>
          </Col>

          <Col lg={3} md={12}>
            <h5 className="fw-bold mb-3" style={{ color: '#00428a' }}>Contact Us</h5>
            <p className="mb-1" style={{ color: '#666' }}>Srikakulam</p>
            <p className="mb-1" style={{ color: '#666' }}>Andhra Pradesh</p>
            <p className="mb-3" style={{ color: '#666' }}>India - 532284</p>
            <p className="mb-1" style={{ color: '#666' }}><strong>Phone:</strong> +91 6303 179 166</p>
            <p className="mb-1" style={{ color: '#666' }}><strong>Email:</strong> noreply@bhitinfotech.com</p>
          </Col>
        </Row>

        <hr className="my-4 border-secondary" />

        <div className="text-center">
          <p className="mb-1" style={{ color: '#666' }}>&copy; 2025 <strong style={{ color: '#55c900' }}>BHIT Infotech</strong>. All rights reserved.</p>
          <p className="mb-0" style={{ color: '#666' }}>Designed & Developed by <strong style={{ color: '#55c900' }}>BHIT Infotech Team</strong></p>
        </div>
      </Container>
    </footer>
  );
};

export default PublicFooter;
